import Catch from './Error/ErrorHandler';
import { Fragment } from 'react';
import { ErrorComponentBehoerdenServer } from './Error/ErrorComponent';
import { FjdBaseLayout } from 'fjd-react-components';
import { Footer } from './Footer/Footer';
import { Header } from './Header/Header';
import { MainNavigation } from './MainNavigation/MainNavigation';
type Props = {
  children: React.ReactNode;
};

export const BehErrorBoundary = Catch(function BehErrorBoundary(
  props: Props,
  error?: Error
) {
  if (error) {
    return (
      <FjdBaseLayout
        footer={<Footer />}
        header={<Header />}
        mainNavigation={<MainNavigation />}
        fullWidthContent
      >
        <ErrorComponentBehoerdenServer />
      </FjdBaseLayout>
    );
  } else {
    return <Fragment>{props.children}</Fragment>;
  }
});
